import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app-reducer';

import { get, find } from 'lodash';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ComposableService } from '../services/composable.service';

@Component({
  selector: 'decision-details',
  templateUrl: './decision-details.component.html'
})

export class DecisionDetailsComponent implements OnInit {
  appState$: Observable<any>;
  appId: string;
  inFEageRange = false;
  decisionTitle = '';
  decisionMsg = '';
  processing: boolean;
  decisionMsgType: any;
  proposedInsured: any;
  productName: any;
  faceAmount: any;
  agentEmailAddress: any;
  processError: any;
  processTimeout: any;
  riskClass: any;
  smokerStatus: any;
  decisionProduct: any;

  constructor(
    private newRelicService: NewRelicService,
    private store: Store<AppState>,
    private router: Router,
    private changeDetection: ChangeDetectorRef,
    private composableService: ComposableService
  ) {
    this.appState$ = store.select('sections');


  }
  backToMiniPortal() {
    window['setTimeout'](() => {
      // erase app memory to prevent old case data from displaying in agent's next case
      this.composableService.resetApplication();
      // go to the mini-portal
      this.router.navigate(['express', 'financial-professional']);
    }, 3000);
  }
  ngOnInit() {
    this.newRelicService.addPageAction('DecisionDetailsComponent ngOnInit', { status: 'initialized' });

    this.processing = true;
    // get questions from state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      this.appId = state.appId; // Access appId from state

      try {
        this.setCoverageDetails(state);

        this.agentEmailAddress = state.agentData.agentEmail ? state.agentData.agentEmail : '';

        if (state.questions) {
          const section: any = find(state.questions, { Name: 'SECTIONDCoverageDetails' });
          const question: any = find(section.Questions, { QuestionName: 'ProductName' });
          const option: any = find(question.QuestionOptions, { Name: this.decisionProduct });
          this.productName = option.DisplayName;
        }

        // Log successful state retrieval
        this.newRelicService.addPageAction('State Retrieved', { status: 'success', appId: this.appId });

      } catch (error) {
        console.log('error', error);
        this.processing = false;
        this.processError = true;

        // Log error in state retrieval
        this.newRelicService.noticeError(error, { appId: this.appId });
      }
      if (get(state, 'decisionInfo') || get(state, 'simulate')) {
        this.updateDecisionInfo(state);
      }
      else {
        this.processing = false;
        this.processError = true;

        // Log missing decision info
        this.newRelicService.addPageAction('Missing Decision Info', { status: 'error', appId: this.appId });
      }

    }, (error) => {
      console.log('error', error);
      this.processing = false;
      this.processError = true;

      // Log error in state subscription
      this.newRelicService.noticeError(error, { appId: this.appId });
    });
  }

  updateDecisionInfo(state: any) {
    const decision = (state.decisionInfo && state.decisionInfo.Rows) ? state.decisionInfo.Rows : null;// get(state, 'decisionInfo.Rows');
    const isSimulation = state.simulate && state.simulate.decision;
    if (this.checkDecisionNumber(decision, 1, isSimulation, state)) {
          // console.log('decisionMsgType=1');
      this.riskClass = this.getRiskClass(decision);
      this.smokerStatus = this.getSmokerStatus(decision);
      this.setDecisionMsg(1);

    } else if (this.checkDecisionNumber(decision, 2, isSimulation, state)) {
          // console.log('decisionMsgType=2');
      this.setDecisionMsg(2);
    } else if (this.checkDecisionNumber(decision, 2.5, isSimulation, state)) {
          // console.log('decisionMsgType=2.5');
      this.setDecisionMsg('2.5');
    }
    else if (this.checkDecisionNumber(decision, 3, isSimulation, state)) {
          // console.log('decisionMsgType=3');
      this.setDecisionMsg(3);
    }
    else if (this.checkDecisionNumber(decision, 4, isSimulation, state)) {
          // console.log('decisionMsgType=4');
      this.setDecisionMsg(4);
    }
    else if (decision) {
          // console.log('unknown decision');
      this.processing = false;
      this.processError = true;

      // Log unknown decision
      this.newRelicService.addPageAction('Unknown Decision', { status: 'error', appId: this.appId });
    }
    else {
          // console.log('no decision');
      this.processing = false;
      this.processError = true;

      // Log no decision
      this.newRelicService.addPageAction('No Decision', { status: 'error', appId: this.appId });
    }

    // Log decision update
    this.newRelicService.addPageAction('Decision Updated', { status: 'success', appId: this.appId });
  }

  getSmokerStatus(decision): any {
    return ((decision && decision[0] && decision[0].SmokerStatus) ? decision[0].SmokerStatus : 'Non-Smoker');
  }

  setCoverageDetails(state) {
    this.proposedInsured = state.content.SECTIONAProposedInsured.Name.FirstName + ' ' + state.content.SECTIONAProposedInsured.Name.LastName;
    this.decisionProduct = state.content.SECTIONDCoverageDetails.ProductName ? state.content.SECTIONDCoverageDetails.ProductName : '';
    const TermFaceAmount = state.content.SECTIONDCoverageDetails.TermFaceAmount ? state.content.SECTIONDCoverageDetails.TermFaceAmount : '0';
    let baseFaceAmount = Number(TermFaceAmount.replace(/\$/g, '').replace(/\,/g, ''));
    if ((isNaN(baseFaceAmount) ? 0 : baseFaceAmount) == 0) {
      baseFaceAmount = this.calculateBaseFaceAmount(state);
    }
    this.faceAmount = baseFaceAmount;
  }

  calculateBaseFaceAmount(state) {
    const FlexiblePremiumProductsBaseAmount: string = state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsBaseAmount ? state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsBaseAmount : "0";
    const ProductsBaseAmount = Number(FlexiblePremiumProductsBaseAmount.replace(/\$/g, '').replace(/\,/g, ''));
    const FlexiblePremiumProductsSupplementalAmount: string = state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsSupplementalAmount ? state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsSupplementalAmount : "0";
    const SupplementalAmount = Number(FlexiblePremiumProductsSupplementalAmount.replace(/\$/g, '').replace(/\,/g, ''));
    const sum = (isNaN(ProductsBaseAmount) ? 0 : ProductsBaseAmount) + (isNaN(SupplementalAmount) ? 0 : SupplementalAmount);
    return sum;
  }

  checkDecisionNumber(decision, decisionType, isSimulation, state) {
    return (decision && get(decision[0], 'TriagePathNumber') == decisionType) || (isSimulation && state.simulate.decision == decisionType);
  }

  setDecisionMsg(msgType) {
    this.processing = false;
    this.decisionMsgType = msgType;
    console.log('setting decision type:', msgType);
    this.processError = false;
    this.changeDetection.detectChanges();

    // Log decision message setting
    this.newRelicService.addPageAction('Set Decision Message', { msgType, appId: this.appId });
  }

  getRiskClass(decision: any) {
    const decisionRiskClass = (decision && decision[0] && decision[0].DecisionClassName) ? decision[0].DecisionClassName : 'SuperPreferred';

    if (decisionRiskClass){
      return decisionRiskClass.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); });
    }
    else{
      return decisionRiskClass;
    }
  }
}
